var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7605 6.5334C15.7641 2.01853 11.8934 0 8.50182 0C8.50182 0 8.50182 0 8.49224 0C5.1102 0 1.24912 2.01853 0.243136 6.52365C-0.887402 11.5553 2.14014 15.8167 4.88026 18.508C5.89583 19.5027 7.19882 20 8.50182 20C9.80481 20 11.1078 19.5027 12.1138 18.508C14.8539 15.8167 17.8815 11.5651 16.7605 6.5334ZM11.1365 9.50756H5.86709C5.47427 9.50756 5.14852 9.17601 5.14852 8.77621C5.14852 8.3764 5.47427 8.04486 5.86709 8.04486H11.1365C11.5294 8.04486 11.8551 8.3764 11.8551 8.77621C11.8551 9.17601 11.5294 9.50756 11.1365 9.50756Z",
    fill: "#065F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1f43fc04d02862c26ec5931fb1af65c9.svg";
export { ForwardRef as ReactComponent };